import { render, staticRenderFns } from "./study-header.vue?vue&type=template&id=30c33cfa&scoped=true&"
import script from "./study-header.vue?vue&type=script&lang=ts&"
export * from "./study-header.vue?vue&type=script&lang=ts&"
import style0 from "./study-header.vue?vue&type=style&index=0&id=30c33cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c33cfa",
  null
  
)

export default component.exports